<template>
    <div :class="[$options.name, { '-bg': $route.name === 'home'}]">
        <navigation-bar />
        <!-- BG -->
        <transition name="fade" mode="out-in">
            <div :class="['background', portraitMode ? '-portrait' : '-landscape']" v-if="$route.name === 'home' && getCurrentSection() < 2 ">
                <div class="illustration">
                    <illustration-svg />
                </div>
            </div>
        </transition>
        <!-- Routes -->
        <router-view :class="['view', { fixedHeight: isMenuOpen }]" ref="routerView" />

        <template v-if="!isMobileSize">
            <mentions />
        </template>
        
        <!-- NAVIGATION -->
        <menu-overlay v-if="isMenuOpen" />

        <preloader />
    </div>
</template>
<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { gsap, Sine, easeInOut } from 'gsap'
import Mentions from '@/components/Mentions'
import Preloader from '@/components/Preloader'
import MenuOverlay from '@/components/MenuOverlay'
import NavigationBar from '@/components/NavigationBar'
import illustrationSvg from '@/components/IllustrationSvg'

export default {
    name: 'app',
    components: {
        'mentions': Mentions,
        'preloader': Preloader,
        'menu-overlay': MenuOverlay,
        'navigation-bar': NavigationBar,
        'illustration-svg': illustrationSvg
    },
    data() {
        return {
            tl: false,
            isPageReaveled: false,
            colors: ['#01abaa', '#ffc420', '#fea680']
        }
    },
    computed: {
        currentRouteName() {
            return this.$route.name
        },
        ...mapGetters({
            isMenuOpen: 'isMenuOpen',
            isPreloading: 'isPreloading',
            getFullPageApi: 'getFullPageApi',
            homePageSections: 'getHomePageSections'
        })
    },
    mounted() {
        this.detectDevice()
        window.addEventListener('resize', this.resizeApplication)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeApplication)
    },
    methods: {
        resizeApplication() {
            this.$bus.$emit(this.$bus.RESIZE_WINDOW)
            this.debounceMethod(this.detectDevice)
        },
        getCurrentSection() {
            return this.getFullPageApi ? this.getFullPageApi.getActiveSection().index : 0
        },
        detectDevice() {
            this.$store.dispatch('monitorDeviceInfo')
            let vh = window.innerHeight * 0.01
            document.documentElement.style.setProperty('--vh', `${vh}px`)
        },
        enterAnimation(el, done) {
            if (this.$route.name !== 'project') {
                let layers = this.$refs.revealer.childNodes
                layers.forEach((layer, index) => {
                    layer.style.backgroundColor = this.colors[index]
                })
                this.tl = gsap.timeline()
                this.tl
                    .staggerFrom(
                        layers,
                        1,
                        {
                            x: '-100%',
                            width: '0%',
                            autoAlpha: 1,
                            ease: Sine.easeInOut
                        },
                        0.1
                    )
                    .staggerTo(
                        layers,
                        1,
                        {
                            x: '100%',
                            right: '0%',
                            ease: Sine.easeInOut
                        },
                        0.1,
                        "-=0.5"
                    )
                    .to(
                        layers,
                        0.3,
                        { 
                            autoAlpha: 0, 
                            onComplete: this.showPage,
                            onCompleteParams: [done]
                        },
                    )
            }
        },
        leaveAnimation() {
            this.isPageReaveled = false
            if (typeof this.$refs.routerView.leaveAnimation === 'function') {
                this.$refs.routerView.leaveAnimation()
            }
        },
        showPage(done) {
            if (typeof done === 'function') {
                done()
            }
            this.isPageReaveled = true
            if (typeof this.$refs.routerView.enterAnimation === 'function') {
                this.$refs.routerView.enterAnimation()
            }
        },
        debounceMethod: _.debounce((fun) => { fun() }, 300),
        throttleMethod: _.throttle((fun) => { fun() }, 500)
    }
}
</script>

<style lang="scss">
@import '@/assets/styles/partials/_reset.scss';
@import '@/assets/styles/app.scss';

.app {
    height: 100%;
    line-height: 1.5;
    font-family: $nunito;
    &.-bg {
        background-color: var(--bg-color);
        transition: background-color 0.5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .view {
        &.fixedHeight {
            height: 100vh;
            height: calc(var(--vh, 1vh) * 100);
            overflow: hidden;
        }
    }

    .background {
        left: 0;
        width: 100vw;
        position: absolute;

        &.-portrait {
            height: 50vh;
            top: $headerHeight;
            @include g-state(tablet) {
                top: $headerHeightDesktop;
            }
            .illustration {
                top: 50%;
                width: 100%;
                position: absolute;
                text-align: center;
                transform: translateY(-50%);
            }
        }
        &.-landscape {
            top: calc((#{$headerHeight} / 2));
            height: calc(100vh - (#{$headerHeight} / 2));
            @include g-state(tablet) {
                top: calc((#{$headerHeightDesktop} / 2));
                height: calc(100vh - (#{$headerHeightDesktop} / 2));
            }
            .illustration {
                top: 50%;
                width: 55%;
                right: 1rem;
                position: absolute;
                transform: translateY(-50%);
            }
        }
    }
}
</style>
